import { JSXElementConstructor, StrictMode } from 'react';
import { Root, createRoot } from 'react-dom/client';

import { addLatestBrandTemplate } from './BrandTemplatePreview.helpers';
import { BrandTemplateData } from './BrandTemplatePreview.type';

declare global {
  interface Window {
    __editor2_render: (element: HTMLElement, brandTemplateData?: BrandTemplateData) => Promise<void>;
  }
}

let AliasApp: JSXElementConstructor<any>;
let lastRootElement: HTMLElement;
let root: Root;

const renderToElement = async (element: HTMLElement, brandTemplateData?: BrandTemplateData) => {
  if (element) {
    const { templateId, colors, fontConfig } = brandTemplateData || {};

    if (!templateId) {
      console.error('Template ID is required');
      return;
    }

    /**
     * Note: we use in memory storage to store the preview data instead of refetching from the server.
     */
    addLatestBrandTemplate({ templateId, colors, fontConfig });

    try {
      if (element === lastRootElement) {
        root.render(
          <StrictMode>
            <AliasApp />
          </StrictMode>,
        );
      } else {
        root = createRoot(element);
        root.render(
          <StrictMode>
            <AliasApp />
          </StrictMode>,
        );
      }
    } catch (error) {
      console.error('Error rendering the app', error);
    }
  }
};

export const initIntegration = (App: JSXElementConstructor<any>) => {
  AliasApp = App;
  window.__editor2_render = renderToElement;
};
